import React from 'react';

const Divider = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="h-6 w-px bg-neutral-200" />
    </div>
  );
};

export default Divider;
